import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { intlShape, injectIntl } from 'react-intl';
import TextField from '../../TextField/TextField';
import { isEmpty } from '../../FormElement/FormElementUtils';


//Copying current pattern matching textinput uses in CAPE
export const isValidCity = (msg) => (value) => {
    const pattern = /^([a-zA-Z0-9\s-]+)$/;

    if (pattern.test(value)) {
        return;
    } else {
        return {
            msg,
            className: 'hasError'
        };
    }
};

export class City extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        validateCity: PropTypes.bool,
        localePrefix: PropTypes.string.isRequired
    };
    static defaultProps = {
        validateCity: true
    };

    render() {
        const { intl, localePrefix, validateCity } = this.props;
        const validate = [
            isEmpty(intl.formatMessage({ id: `${localePrefix}.CITY_IS_NULL` }))
        ];
        if (validateCity) {
            validate.push(
                isValidCity(intl.formatMessage({ id: `${localePrefix}.CITY_INVALID_FORMAT` }))
            );
        }
        return (
            <Field
                id="city"
                name="city"
                autoComplete="disabled"
                autoCorrect="off"
                autoCapitalize="on"
                component={TextField}
                required={true}
                label={intl.formatMessage({ id: `${localePrefix}.city` })}
                validate={validate}
            />
        );
    }
}

export default injectIntl(City);
